var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamRakuten(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52.27 61.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d50210;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_2",
    "data-name": "\\u5716\\u5C64 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5167\\u5BB9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_95QJcT.tif",
    "data-name": "95QJcT.tif"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.69,0c12.23,2.56,20,19.56,6.79,30.87,4.35,5.85,8.66,11.62,13.28,17.82H35.14L24.05,34a29.43,29.43,0,0,0-6.52-.07v14.9H8.39V0Zm-9,24.45c18,2.76,17.79-17.94,0-15.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,54.19H52.22l.05.69L8.54,61C5.27,59.47,3.43,56.09,0,55Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamRakuten);
export default __webpack_public_path__ + "static/media/team_rakuten.db1520df266b7a5532349144e62a003c.svg";
export { ForwardRef as ReactComponent };